import { render, staticRenderFns } from "./PhotoForm.vue?vue&type=template&id=608d37e5"
import script from "./PhotoForm.vue?vue&type=script&lang=js"
export * from "./PhotoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports